import React, { useEffect, useState } from 'react';
import styles from './VerifiedEmailModal.module.scss';
import { useSelectedContext } from 'context/contextSelector';
import { Modal, Button, openNotification } from 'tt-ui-lib/core';
import { useMutation } from '@apollo/client';
import { RESEND_EMAIL_FOR_VERIFICATION } from '../../../api';

const VerifiedEmailModal = () => {
  const { user } = useSelectedContext((context) => context.user);
  const [resendEmailForVerification] = useMutation(RESEND_EMAIL_FOR_VERIFICATION);
  const [isOpen, setIsOpen] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    if (user.id && !user.email_verified_at) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [user]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const resendEmail = async () => {
    setResendLoading(true);
    const response = await resendEmailForVerification({
      variables: {
        email: user.email,
      },
    });

    if (
      response.data &&
      response.data.resendEmailForVerification &&
      response.data.resendEmailForVerification.status === 'SENT'
    ) {
      openNotification({
        type: 'success',
        message: 'Mail sent successfully',
      });
      setIsOpen(false);
    }
    setResendLoading(false);
  };

  return (
    <Modal
      onClose={handleClose}
      open={isOpen}
      title="You have an unverified email"
      className={styles.verifiedEmail}
    >
      <p>You can&apos;t to proceed, because your email address has not been verified.</p>
      <Button type="link" disabled={resendLoading} loading={resendLoading} onClick={resendEmail}>
        Resend email
      </Button>
    </Modal>
  );
};

export default VerifiedEmailModal;
